<template>
  <div class="box">
    <el-drawer
      :visible.sync="visible"
      :wrapperClosable="false"
      :size="size"
      custom-class="drawer1"
      @close="cancelBtn"
    >
      <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">项目信息</div>
      <el-card style="margin:0px 10px 50px;">
        <el-row>
          <el-col :span="6" class="left">
            <div class="avatar">
              <img
                v-if="baseInfo.paper_picid > 0"
                :src="baseInfo.pic_path"
                alt
                :onerror="onerrorDefaultImg"
              />

              <img v-else :src="defaultImg" title="众筹项目默认封面" />
            </div>
            <div style="margin-top:20px" class="left-bottom">
              <p>
                项目起止日期：
                <span>{{baseInfo.regdate_start}} 至 {{baseInfo.regdate_end}}</span>
              </p>

              <p>
                项目周期：
                <span>{{baseInfo.project_cycle}}</span> 个月
              </p>

              <p>
                受益人群：
                <span>{{baseInfo.beneficiary_number}}</span>
              </p>

              <template v-if="Number(aid) > 0">
                <p>
                  项目总分配金额：
                  <span style="color:red">{{otherMoney.top_money | setNumFormat}}</span> 元
                </p>
                <p>
                  已拨款金额：
                  <span style="color:red">{{otherMoney.settled_money | setNumFormat}}</span> 元
                </p>
                <p>
                  未拨款金额：
                  <span style="color:red">{{otherMoney.unsettled_money | setNumFormat}}</span> 元
                </p>
                <p>
                  项目预扣款金额：
                  <span style="color:red">{{otherMoney.balance | setNumFormat}}</span> 元
                </p>
              </template>
            </div>
          </el-col>
          <el-col :span="18">
            <div style="margin-bottom:20px;">
              <h4>
                [{{baseInfo.project_type_text}}] {{baseInfo.project_name}}
                <span
                  v-if="baseInfo.contract"
                  style="margin-left:10px"
                >
                  <el-tag
                    type="warning"
                    v-if="baseInfo.contract.foundagree == 0"
                    effect="dark"
                    size="small"
                  >待审核</el-tag>
                  <el-tag
                    type="success"
                    v-else-if="baseInfo.contract.foundagree == 1"
                    effect="dark"
                    size="small"
                  >已通过</el-tag>
                  <el-tag
                    type="danger"
                    v-else-if="baseInfo.contract.foundagree == 2"
                    effect="dark"
                    size="small"
                  >未通过</el-tag>
                </span>
                <span v-else>
                  <el-tag type="info" effect="dark" size="small">未申请</el-tag>
                </span>
              </h4>
            </div>
            <el-tabs v-model="activeName" type="border-card" style="width:98%">
              <el-tab-pane label="基础信息" name="1">
                <!-- <el-card style="margin:10px;">
                  <div slot="header">
                    <span>项目规模</span>
                  </div>

                  <div>{{baseInfo.project_scale}}</div>
                </el-card>-->
                <el-card style="margin:10px;" v-if="baseInfo.project_type == 1">
                  <div slot="header">
                    <span>资金使用标准</span>
                  </div>
                  <el-table :data="baseInfo.funds" border :max-height="400">
                    <el-table-column
                      prop="apply_user_type_text"
                      label="贫困类别"
                      width="200"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="cost_item_text"
                      label="眼疾"
                      align="center"
                      min-width="200"
                    >
                      <template slot-scope="scope">
                        <span>{{scope.row.cost_item_text.join('、')}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="unit_text" label="眼别" width="140" align="center"></el-table-column>
                    <el-table-column label="区间金额" width="220" align="center">
                      <template slot-scope="scope">
                        <div>{{scope.row.funds_start | setNumFormat}} - {{scope.row.funds_end | setNumFormat}}</div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-card>

                <!-- <el-card style="margin:10px;">
                  <div slot="header">
                    <span>项目负责人信息</span>
                  </div>

                  <div>{{baseInfo.project_master}}</div>
                </el-card>-->

                <el-card style="margin:10px;">
                  <div slot="header">
                    <span>项目申请必读协议/模板</span>
                  </div>

                  <!-- <span
                    v-for="(item,index) in baseInfo.agreements"
                    :key="index"
                    @click="downFile(item.id, item.name)"
                    style="text-decoration: underline;cursor: pointer;color:#4682B4;margin-right:8px "
                  >{{item.template_name}}</span>-->

                  <a
                    style="margin-right:8px;"
                    :href="item.file_url"
                    target="_blank"
                    v-for="(item,index) in baseInfo.agreements"
                    :key="index"
                  >{{item.template_name}}</a>
                  <p style="clear: both; padding-top: 10px">
                    <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击文件名可进行下载
                  </p>
                </el-card>

                <!-- <el-card style="margin:10px;" v-if="baseInfo.project_type == 1">
                  <div slot="header">
                    <span>救助申请相关附件/模板</span>
                  </div>
                  <span
                    v-for="(item,index) in baseInfo.files"
                    :key="index"
                    @click="downFile(item.id, item.name)"
                    style="text-decoration: underline;cursor: pointer;color:#4682B4;margin-right:8px "
                  >{{item.template_name}}</span>
                  <p style="clear: both; padding-top: 10px">
                    <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击文件名可进行下载
                  </p>
                </el-card>-->

                <!-- <el-card style="margin:10px;">
                  <div slot="header">
                    <span>所提交的项目申请附件</span>
                  </div>

                  <div v-if="baseInfo.contract && baseInfo.contract.files">
                    <a
                      style="margin-right:8px;"
                      :href="item.file_url"
                      target="_blank"
                      v-for="(item,index) in baseInfo.contract.files"
                      :key="index"
                    >{{item.file_source_name}}</a>
                    <p style="clear: both; padding-top: 10px">
                      <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击文件名可进行下载
                    </p>
                  </div>
                  <div v-else>您还暂未申请该项目~</div>
                </el-card>-->

                <!-- <el-card style="margin:10px;">
                  <div slot="header">
                    <span>项目计划书</span>
                  </div>
                  <div v-if="baseInfo.plan_file_path && baseInfo.plan_file_path[0]">
                    <a
                      style="margin-right:8px;"
                      :href="item.url"
                      v-for="(item,index) in baseInfo.plan_file_path"
                      :key="index"
                      target="_blank"
                    >{{item.name}}</a>
                    <p style="clear: both; padding-top: 10px">
                      <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击文件名可进行下载
                    </p>
                  </div>
                  <div v-else>您还暂未申请该项目~</div>
                </el-card>-->
              </el-tab-pane>
              <el-tab-pane label="申请情况" name="2">
                <apply-list :id="pid" v-if="activeName == '2'"></apply-list>
              </el-tab-pane>
              <el-tab-pane label="拨款情况" name="3">
                <payment-list :id="pid" v-if="activeName == '3'" :type="baseInfo.project_type"></payment-list>
              </el-tab-pane>
              <el-tab-pane label="媒体报告" name="4">
                <media-list :id="pid" v-if="activeName == '4'"></media-list>
              </el-tab-pane>
              <!-- <el-tab-pane label="阶段报告" name="4">
                <report-list :id="pid" v-if="activeName == '4'"></report-list>
              </el-tab-pane>-->
            </el-tabs>
          </el-col>
        </el-row>
      </el-card>

      <div class="drawer-footer">
        <el-button type="danger" size="small" icon="el-icon-close" @click="cancelBtn">关闭</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import mediaList from "./detail_media";
import applyList from "./detail_apply";
import paymentList from "./detail_payment";
import reportList from "./detail_report";
export default {
  components: {
    mediaList,
    paymentList,
    reportList,
    applyList
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "项目信息"
    },
    size: {
      type: [String, Number],
      default: "85%"
    },

    //申请id
    aid: {
      type: [String, Number],
      default: null
    },
    pid: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      visible: false,
      loading: false,
      activeName: "1",
      baseInfo: { contract: {} }, //基础信息
      otherMoney: {}, //相关金额

      defaultImg: require("@/assets/images/news.png"),
      onerrorDefaultImg:
        'this.src="' + require("@/assets/images/news.png") + '"'
    };
  },
  methods: {
    cancelBtn() {
      this.visible = false;
    },
    // 获取基础信息
    getBaseInfo() {
      let loading = this.$loading({
        text: "数据正在加载中……"
      });
      this.$db
        .post(this.$db.config.getCfProInfo, { id: this.pid })
        .then(res => {
          if (res && res.code == 200) {
            this.baseInfo = res.data;
            loading.close();
          }
        });
    },

    //获取相关金额
    getMoney() {
      this.$db
        .post(this.$db.config.getUnitMoneyByProId, {
          project_id: this.pid,
          project_apply_id: this.aid
        })
        .then(res => {
          //获取该项目相关金额
          if (res && res.code == 200) {
            for (const key in res.data) {
              this.otherMoney[key] = this.setMoneyFormat(res.data[key]);
            }
          }
        });
    },

    downFile(id, name) {
      this.$db
        .downFilePost(this.$db.config.downloadFileUrl, { file_id: id })
        .then(res => {
          if (res.hasOwnProperty("code")) {
            var enc = new TextDecoder("utf-8");
            var result = JSON.parse(enc.decode(new Uint8Array(res)));
            if (result.code !== 200) {
              this.$message.warning(result.msg);
            }
          } else {
            this.download(res, name);
          }
        });
    },
    // 下载文件
    download(data, name) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = url;
      alink.download = name; //文件名
      alink.click();
      this.downConfirm = false;
    },

    //千分化金额
    setMoneyFormat(num) {
      let value = typeof num === "number" ? num : Number(num);
      return (value.toFixed(2) + "").replace(
        /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
        "$&,"
      );
    }
  },
  watch: {
    visible(val) {
      this.$emit("input", val);
    },

    value: {
      handler(val) {
        this.visible = val;
      },
      immediate: true
    }
  },
  mounted() {
    if (this.pid > 0) {
      this.getBaseInfo();
    }

    if (Number(this.aid) > 0) {
      this.getMoney();
    }
  }
};
</script>

<style lang="scss" scoped>
.box /deep/ .drawer1 {
  overflow: auto;
  .left {
    .avatar {
      display: flex;
      align-items: center;
      width: calc(100% - 50px);
      max-height: 300px;
      padding: 5px;
      margin-bottom: 20px;
      justify-content: center;
      border: 1px solid #ddd;
      img {
        border: 1px solid #ddd;
        border-radius: 3px;
        width: 100%;
        height: 100%;
      }
    }

    .left-bottom {
      p {
        padding: 5px;
        font-size: 0.8em;
        span {
          color: #999;
          font-size: 0.6em;
        }
      }
    }
  }

  .drawer-footer {
    width: 80%;
    position: fixed;
    bottom: 0;
    right: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/info/detail.vue